import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['sn', 'monthandyear', 'withdrawDay', 'totalRequestedAmount', 'Actions']),
  desc: z.boolean(),
});

const affiliateSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z.union([z.string(), z.array(z.string())]).optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/payment-management/affiliate-log/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => affiliateSearchSchema.parse(search),
});

import { useGetAffiliateLog } from '@/features/payment-management/affiliate-log/hooks/useGetAffiliateLog';
import { AffiliateLogTable } from '@/features/payment-management/affiliate-log/table';
import { AffiliateData } from '@/services/payment/payment.types';

const dummyAffiliateData: AffiliateData[] = Array.from({ length: 25 }).map((_, index) => ({
  sn: String(index + 1),
  id: `affiliate-log-${index + 1}`,
  monthandyear: `2024-${String((index % 12) + 1).padStart(2, '0')}`,
  withdrawDay: '15',
  totalRequestedAmount: 10000 + index * 500,
}));

function RouteComponent() {
  const { isLoading, pagination } = useGetAffiliateLog();

  return (
    <div className="flex flex-col gap-6">
      <AffiliateLogTable data={dummyAffiliateData} pagination={pagination} loading={isLoading} />
    </div>
  );
}
